import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: 'https://7a70f98f0140419aae568ac012a6fae9@sentry-next.wixpress.com/7526',
});

export { ErrorBoundary } from '@sentry/react';
